import React, { useState } from "react"
import styled from "styled-components"

import q1a1 from "../../images/q1/a1.png"
import q1a2 from "../../images/q1/a2.png"
import q1a3 from "../../images/q1/a3.png"
import q1a4 from "../../images/q1/a4.png"

import q2a1 from "../../images/q2/a1.png"
import q2a2 from "../../images/q2/a2.png"
import q2a3 from "../../images/q2/a3.png"
import q2a4 from "../../images/q2/a4.png"

import q3a1 from "../../images/q3/a1.png"
import q3a2 from "../../images/q3/a2.png"
import q3a3 from "../../images/q3/a3.png"
import q3a4 from "../../images/q3/a4.png"

import q4a1 from "../../images/q4/a1.png"
import q4a2 from "../../images/q4/a2.png"
import q4a3 from "../../images/q4/a3.png"
import q4a4 from "../../images/q4/a4.png"

import r1 from "../../images/results/r1.png"
import r2 from "../../images/results/r2.png"
import r3 from "../../images/results/r3.png"
import r4 from "../../images/results/r4.png"

export default function Quiz() {
    const questions = [
        {
            questionText: 'What do you look forward to most when you holiday?',
            answerOptions: [
                { answerText: 'Adventure', keys: [2, 1, 3, 0], answerImg: q1a1 },
                { answerText: 'Local culture', keys: [1, 3, 1, 0], answerImg: q1a2 },
                { answerText: 'Sight-seeing', keys: [1, 3, 2, 1], answerImg: q1a3 },
                { answerText: 'Just chilling', keys: [1, 1, 0, 3], answerImg: q1a4 },
            ],
        },
        {
            questionText: 'What do you enjoy most when you get there?',
            answerOptions: [
                { answerText: 'Great local food', keys: [0, 3, 2, 1], answerImg: q2a1 },
                { answerText: 'Nature', keys: [3, 1, 2, 0], answerImg: q2a2 },
                { answerText: 'Famous landmarks', keys: [1, 3, 1, 0], answerImg: q2a3 },
                { answerText: 'Nightlife', keys: [0, 0, 0, 3], answerImg: q2a4 },
            ],
        },
        {
            questionText: 'Which of these would you like most with you on a holiday?',
            answerOptions: [
                { answerText: 'Camera', keys: [2, 3, 1, 0], answerImg: q3a1 },
                { answerText: 'Book', keys: [0, 1, 0, 3], answerImg: q3a2 },
                { answerText: 'Beach slippers', keys: [2, 0, 1, 3], answerImg: q3a3 },
                { answerText: 'Safari hat', keys: [2, 1, 3, 0], answerImg: q3a4 },
            ],
        },
        {
            questionText: 'Where would you love to holiday next?',
            answerOptions: [
                { answerText: 'Rome', keys: [1, 3, 1, 1], answerImg: q4a1 },
                { answerText: 'Mauritius', keys: [1, 0, 1, 3], answerImg: q4a2 },
                { answerText: 'Vietnam', keys: [2, 3, 1, 1], answerImg: q4a3 },
                { answerText: 'Nepal', keys: [2, 1, 3, 0], answerImg: q4a4 },
            ],
        },
    ];

    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [showScore, setShowScore] = useState(false);
    
    const [score1, setScore1] = useState(0);
    const [score2, setScore2] = useState(0);
    const [score3, setScore3] = useState(0);
    const [score4, setScore4] = useState(0);

    const [final, setFinal] = useState("");
    const [finalIndex, setFinalIndex] = useState(0);
    const [temp, setTemp] = useState(0);

    const results = ["Nature Lover", "Local Explorer", "Thrill Seeker", "Unwinder"];
    const resultImages = [r1, r2, r3, r4];

    const indexOfMax = (arr) => {
        if (arr.length === 0) {
            return -1;
        }
    
        var max = arr[0];
        var maxIndex = 0;
    
        for (var i = 1; i < arr.length; i++) {
            if (arr[i] > max) {
                maxIndex = i;
                max = arr[i];
            }
        }
    
        return maxIndex;
    }

    const handleAnswerOptionClick = (keys) => {

        setScore1(score1 + keys[0]);
        setScore2(score2 + keys[1]);
        setScore3(score3 + keys[2]);
        setScore4(score4 + keys[3]);

        const nextQuestion = currentQuestion + 1;
        if (nextQuestion < questions.length) {
            setCurrentQuestion(nextQuestion);
        } else {
            var arr = [score1, score2, score3, score4];
            var maxIndex = indexOfMax(arr);
            setFinalIndex(maxIndex);
            setFinal(results[maxIndex]);
            setShowScore(true);
        }
    };

    return (
		<div className='app'>
			{showScore ? (
				<ScoreSection>
                    <img src={resultImages[finalIndex]}></img>
					<div>You are the {final}!</div>
                    <PromoText>
                        Now that you know the kind of traveller you are, why wait?
                        <br />
                        <br />
                        Pick up the right travel gear now at very attractive discounts. Click the button below.
                    </PromoText>
                    <SiteLink href="https://www.amazon.in/stores/VIP/page/E4301F95-F4F9-4208-B019-CEE9BA4B849F?ref_=ast_bln">
                        <VIPButton>Shop at VIP</VIPButton>
                    </SiteLink>
				</ScoreSection>
			) : (
				<>
					<QuestionSection>
						<QuestionCount>
							Question {currentQuestion + 1} / {questions.length}
						</QuestionCount>
						<QuestionText>
                            { questions[currentQuestion].questionText }
                        </QuestionText>
					</QuestionSection>
					<AnswerSection>
						{questions[currentQuestion].answerOptions.map((answerOption) => (
							<AnswerButton onClick={() => handleAnswerOptionClick(answerOption.keys)}>
                                <img src={answerOption.answerImg}></img>
                                <div>{answerOption.answerText}</div>
                            </AnswerButton>
						))}
					</AnswerSection>
				</>
			)}
		</div>
	);
}

export const QuizContainer = styled.div`
`

export const QuestionText = styled.div`
  color: white;
  margin-top: 16px;
  line-height: 1.2;
`

export const QuestionCount = styled.div`
  color: white;
  font-size: 14px;
`

export const AnswerButton = styled.div`
  width: 44%;
  color: #000;
  margin-right: 20px;
  margin-bottom: 20px;
  padding: 12px 12px;

  border-radius: 16px;
  background: #ffffff;

  display: flex;
  flex-direction: column;

  font-size: 18px;
  cursor: pointer;
`

export const AnswerSection = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 32px;
  margin-left: 20px;
  margin-right: 20px;
`

export const QuestionSection = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 32px;
  font-size: 24px;
`

export const ScoreSection = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 32px;
  font-size: 24px;
  color: white;
`

export const PromoText = styled.div`
  font-size: 18px;
  margin-top: 20px;
  margin-bottom: 32px;
  line-height: 1.5;
`

export const VIPButton = styled.div`
  width: 90%;
  background: white;
  color: black;
  font-size: 18px;
  padding: 12px 20px;
  margin-bottom: 32px;
  border-radius: 10px;
  cursor: pointer;
  text-align: center;
`

export const SiteLink = styled.a`
  text-decoration: none;
  color: white;
`